<template>
  <div class="m-4 text-white">
    <div class="flex flex-row gap-2 items-center my-2">
      <button class="rounded-full bg-paleta-3" @click="volver">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            fill="currentColor"
            d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
          ></path>
        </svg>
      </button>
      <div class="text-white text-base">Resultados carrera</div>
    </div>

    <div class="flex mt-5 bg-teal-500 rounded-t-md px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-4/12 text-left text-teal-200">Hipódromo:</div>
      <div class="w-4/12 text-left font-bold text-teal-100">{{ datosCarrera.hipodromo }}</div>
      <div class="w-4/12 text-right text-teal-100">{{ format(parseISO(datosCarrera.hora), "dd/MM/yyyy") }}</div>
    </div>
    <div class="flex bg-teal-500 rounded-b-md px-2 pb-2 w-full gap-3 shadow-xl">
      <div class="w-4/12 text-left text-teal-200">Carrera:</div>
      <div class="w-4/12 text-left font-bold text-teal-100">{{ datosCarrera.numero }}</div>
      <div class="w-4/12 text-right text-teal-100">{{ format(parseISO(datosCarrera.hora), "HH:mm") }}</div>
    </div>

    <div class="flex mt-1 bg-teal-500 rounded-t-md px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5 font-bold">Pos</div>
      <div class="w-1/5 font-bold">Mar</div>
      <div class="w-1/5 font-bold">GA</div>
      <div class="w-1/5 font-bold">PL</div>
      <div class="w-1/5 font-bold">TE</div>
    </div>
    <div class="flex bg-teal-500 px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5">I</div>
      <div class="w-1/5">{{ sports.posicion1 }}</div>
      <div class="w-1/5">{{ sports.ganador1 }}</div>
      <div class="w-1/5">{{ sports.place1 }}</div>
      <div class="w-1/5">{{ sports.tercero1 }}</div>
    </div>
    <div class="flex bg-teal-500 px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5">II</div>
      <div class="w-1/5">{{ sports.posicion2 }}</div>
      <div class="w-1/5"></div>
      <div class="w-1/5">{{ sports.place2 }}</div>
      <div class="w-1/5">{{ sports.tercero2 }}</div>
    </div>
    <div class="flex bg-teal-500 px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5">III</div>
      <div class="w-1/5">{{ sports.posicion3 }}</div>
      <div class="w-1/5"></div>
      <div class="w-1/5"></div>
      <div class="w-1/5">{{ sports.tercero3 }}</div>
    </div>
    <div class="flex bg-teal-500 px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5">IV</div>
      <div class="w-1/5">{{ sports.posicion4 }}</div>
      <div class="w-1/5"></div>
      <div class="w-1/5"></div>
      <div class="w-1/5"></div>
    </div>
    <div class="flex bg-teal-500 px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5">V</div>
      <div class="w-1/5">{{ sports.posicion5 }}</div>
      <div class="w-1/5"></div>
      <div class="w-1/5"></div>
      <div class="w-1/5"></div>
    </div>

    <div v-for="sport in sports.sports" v-bind:key="sport" class="flex bg-teal-500 px-2 pt-2 w-full gap-3 shadow-xl">
      <div class="w-1/5">{{ sport.tipoApuestaId }}</div>
      <div class="w-3/5">{{ sport.posiciones }}</div>
      <div class="w-1/5">{{ sport.pago }}</div>
    </div>

    <div class="flex bg-teal-500 rounded-t-md px-2 pt-2 w-full gap-3 shadow-xl mt-1">
      <div class="w-1/5 text-left text-sm">Jockey</div>
      <div class="w-4/5 text-left text-sm">{{ sports.jockey }}</div>
    </div>
    <div class="flex bg-teal-500 rounded-b-md px-2 pb-2 w-full gap-3 shadow-xl">
      <div class="w-1/5 text-left text-sm">Gana por</div>
      <div class="w-4/5 text-left text-sm">{{ sports.ganadaPor }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { format, parseISO } from "date-fns";
import differenceInMinutes from "date-fns/differenceInMinutes";

export default {
  data: function() {
    return {
      format,
      parseISO,
      differenceInMinutes
      //carreras: this.$store.getters.carrerasApostables
    };
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    click: function(carreraId) {
      this.$store.dispatch("carreraSeleccionadaApuesta", { carreraId });
      this.$router.push({ path: "/resultados" });
    }
  },
  computed: {
    ...mapState({
      datosCarrera: state => state.resultados.carreras.find(c => c.id == state.resultados.carreraSeleccionada.id),
      sports: state => state.resultados.carreraSeleccionada
    })
  }
};
</script>
